import { Controller } from "@hotwired/stimulus"

// Pushes a Google Ads Enhanced Conversions payload to the GTM dataLayer
// when the customer reaches the booking confirmation page.
//
// The Rails partial only renders the host element when:
//   - Rails.env.production?
//   - the one-shot session flag was set by the preceding accept POST
//   - the user has an email
//
// All values come from data-* attributes; the controller never builds the
// payload — it just forwards it to GTM. GTM-side configuration (per-location
// trigger, conversion tag with EC variable mapping) is owned by Google's team.
//
// See: lib/specs/enhanced_conversions_accept_estimate.md
export default class extends Controller {
  static values = { payload: Object }

  connect() {
    if (!this.hasPayloadValue) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(this.payloadValue)
  }
}
